import React from "react";

function BasicBackBoard(props) {
  return (
    <div
      className="basic-back-board"
      style={{ minHeight: props.minHeight ?? "0" }}
    >
      {props.children}
    </div>
  );
}

export default React.memo(BasicBackBoard);
